import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  TextField,
  Grid,
  Box,
  Modal,
  MenuItem,
  Select,
  Button,
  Paper,
  FormHelperText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Tooltip,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { Info as InfoIcon } from "@mui/icons-material";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function Enquiry() {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [missingFields, setMissingFields] = useState([]);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [loadingBarProgress, setLoadingBarProgress] = useState('');
  const [purposes, setPurposes] = useState([]);
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [modes, setModes] = useState([]);
  const [enquiryData, setEnquiryData] = useState({
    enquiryCode: "",
    enquiryDate: new Date().toISOString().split('T')[0], // Set to today's date
    followupDate: new Date(new Date().setDate(new Date().getDate() + 2)).toISOString().split('T')[0], // Set to today + 2 days
    purposeId: "",
    modeId: "",
    classId: "",
    contactNo: "",
    parentAndGurdianName: "",
    refrence: "",
    emailId: "",
    remark: "",
    createdBy: 0,
    teacherId: "",
    studentName: "",
    motherName: "",
    amount: 0,
    alternateMobile: ""
  });

  const [mandatoryFieldsError, setMandatoryFieldsError] = useState(false);
  const [contactCheckMessage, setContactCheckMessage] = useState('');
  const [contactCheckMessageColor, setContactCheckMessageColor] = useState('');
  const [enquiryExists, setEnquiryExists] = useState(false);
  const [enquiryMessage, setEnquiryMessage] = useState("");
  const [modalOpen, setModalOpen] = useState(false);

  // Info modal state
  const [showInfoModal, setShowInfoModal] = useState(false);

  const navigate = useNavigate();

  const handleModalOpen = () => setModalOpen(true);
  const handleModalClose = () => {
    setModalOpen(false);
    // Reset the enquiryData to its initial state
    setEnquiryData({
      enquiryCode: "",
      enquiryDate: new Date().toISOString().split('T')[0],
      followupDate: new Date(new Date().setDate(new Date().getDate() + 2)).toISOString().split('T')[0],
      purposeId: "",
      modeId: "",
      classId: "",
      // contactNo: "",
      parentAndGurdianName: "",
      refrence: "",
      emailId: "",
      remark: "",
      createdBy: 0,
      teacherId: "",
      studentName: "",
      motherName: "",
      amount: 0,
      alternateMobile: ""
    });
  };


  const checkEnquiryByMobile = async (contactNo) => {
    const apiUrl = "https://wsmsv1.aidigitalsec.com/api/Enquiry/GetEnquiryByMobile";
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": sessionStorage.getItem("token")
        },
        body: JSON.stringify({ contactNo }),
      });
      const responseData = await response.json();

      // Check if there are existing inquiries
      if (responseData && responseData.length > 0) {
        setEnquiryMessage("Enquiries found for this contact number. You can create a new enquiry.");
        setEnquiryExists(true);
      } else {
        setEnquiryMessage("No enquiries found for this contact number. You can create a new enquiry.");
        setEnquiryExists(false);
      }
    } catch (error) {
      console.error("Error fetching enquiry:", error);
      setEnquiryMessage("Failed to check enquiry. Please try again.");
      setEnquiryExists(false);
    }
  };


  const handleContactChange = (e) => {
    const contactNo = e.target.value;
    if (/^\d{0,10}$/.test(contactNo)) { // Validate mobile number length
      setEnquiryData({ ...enquiryData, contactNo });
      if (contactNo.length === 10) {
        checkEnquiryByMobile(contactNo);
      }
    }
  };


  const fetchEnquiryDetails = async (contactNo) => {
    const apiUrl = "https://wsmsv1.aidigitalsec.com/api/Enquiry/GetEnquiryByMobile";
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": sessionStorage.getItem("token")
        },
        body: JSON.stringify({ contactNo }),
      });
      const enquiryDetails = await response.json();
      if (enquiryDetails.length > 0) {
        setEnquiryData(enquiryDetails[0]);
        handleModalOpen();
      }
    } catch (error) {
      console.error("Error fetching enquiry details:", error);
    }
  };

  const formatDate = (dateString) => {
    const dateParts = dateString.split("-");
    const formattedDate = `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
    return formattedDate;
  };

// Add this constant at the top of the component, after the imports or state declarations
const notificationUrl = "https://wsmsv1.aidigitalsec.com/api/Notifications/PostAssignmentNotification";

// Updated handleSubmit function
const handleSubmit = async (event) => {
  event.preventDefault();

  const mandatoryFields = [
    { name: 'Enquiry Date', value: enquiryData.enquiryDate },
    { name: 'Next Follow Up Date', value: enquiryData.followupDate },
    { name: 'Purpose', value: enquiryData.purposeId },
    { name: 'Mode', value: enquiryData.modeId },
    { name: 'Class', value: enquiryData.classId },
    { name: 'Contact No.', value: enquiryData.contactNo },
    { name: 'Assigned To', value: enquiryData.teacherId },
    { name: 'Father Name', value: enquiryData.parentAndGurdianName },
    { name: 'Student Name', value: enquiryData.studentName }
  ];

  const missing = mandatoryFields.filter(field => !field.value);
  setMissingFields(missing.map(field => field.name));

  if (missing.length > 0) {
    setMandatoryFieldsError(true);
    return;
  }

  // Continue with the form submission if no fields are missing
  try {
    setLoadingBarProgress(30);
    const formattedEnquiryDate = formatDate(enquiryData.enquiryDate);
    const formattedFollowupDate = formatDate(enquiryData.followupDate);
    const payload = {
      ...enquiryData,
      enquiryDate: formattedEnquiryDate,
      followupDate: formattedFollowupDate
    };

    const url = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem("token");
    const userId = parseInt(sessionStorage.getItem("userId")) || 0;
    const clientName = sessionStorage.getItem("clientName") || "";

    const response = await fetch(`${url}/Enquiry/InsertEnquirySchool`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": token
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const responseData = await response.json();

    // Send notification for the successfully added enquiry
    const message = `${clientName} created enquiry ${enquiryData.enquiryCode || "New"} for ${enquiryData.parentAndGurdianName}`;
    const notifBody = {
      userId,
      message,
      name: clientName
    };

    await fetch(notificationUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(notifBody),
    }).catch((err) => {
      console.error("Notification API Error:", err);
      // Optionally handle notification failure without blocking the success message
    });

    // Reset form after successful submission
    setEnquiryData({
      enquiryCode: "",
      enquiryDate: new Date().toISOString().split('T')[0],
      followupDate: new Date(new Date().setDate(new Date().getDate() + 2)).toISOString().split('T')[0],
      purposeId: "",
      modeId: "",
      classId: "",
      contactNo: "",
      parentAndGurdianName: "",
      refrence: "",
      emailId: "",
      remark: "",
      createdBy: 0,
      teacherId: "",
      studentName: "",
      motherName: "",
      amount: 0,
      alternateMobile: ""
    });

    setLoadingBarProgress(100);
    setShowSuccessModal(true);
  } catch (error) {
    setLoadingBarProgress(0);
    console.error("Error submitting enquiry:", error);
    // alert("Failed to submit enquiry. Please try again later.");
    setSnackbarMessage('Failed to submit enquiry. Please try again later.');
    setOpenSnackbar(true);
    setSnackbarSeverity("error")
  }
};



  useEffect(() => {
    let isMounted = true;
    let hasShownAlert = false;
    const fetchDropdownData = async () => {
      try {
        const apiUrl = process.env.REACT_APP_BASE_URL;
        const token = sessionStorage.getItem("token");
        if (!apiUrl) {
          throw new Error("API URL is not defined in environment variables.");
        }
        const headers = {
          "Content-Type": "application/json",
          "Authorization": token || "",
        };
        const fetchData = async (url, name) => {
          const response = await fetch(url, {
            method: "POST",
            headers,
            body: JSON.stringify({})
          });
          if (!response.ok) {
            throw new Error(`${name} fetch failed with status: ${response.status}`);
          }
          const data = await response.json();
          if (data.data === null && data.msg === "Record Not Found") {
            if (isMounted && !hasShownAlert) {
              console.warn(`No records found for ${name}`);
              // alert(`No records found for ${name}`);
              setSnackbarMessage(`No records found for ${name}`);
              setOpenSnackbar(true);
              setSnackbarSeverity("error")
              hasShownAlert = true;
            }
            return null;
          }
          return data;
        };
        const [modeData, purposeData, classData, teacherData] = await Promise.all([
          fetchData(`${apiUrl}/Enquiry/ddlMode`, "Mode"),
          fetchData(`${apiUrl}/Enquiry/ddlPurpose`, "Purpose"),
          fetchData(`${apiUrl}/Enquiry/ddlClassName`, "Class"),
          fetchData(`${apiUrl}/Enquiry/ddlTeacher`, "Teacher")
        ]);
        if (isMounted) {
          if (modeData) setModes(modeData);
          if (purposeData) setPurposes(purposeData);
          if (classData) setClasses(classData);
          if (teacherData) setSubjects(teacherData);
        }
      } catch (error) {
        console.error("Error fetching dropdown data:", error);
        if (isMounted && !hasShownAlert) {
          // alert("Failed to load dropdown data. Please check the console for more details.");
          setSnackbarMessage("Failed to load dropdown data. Please check the console for more details.");
              setOpenSnackbar(true);
              setSnackbarSeverity("error")
          hasShownAlert = true;
        }
      }
    };
    fetchDropdownData();
    return () => {
      isMounted = false;
    };
  }, []);

  const handleReset = () => {
    setEnquiryData({
      enquiryCode: "New",
      enquiryDate: new Date().toISOString().split('T')[0],
      followupDate: new Date(new Date().setDate(new Date().getDate() + 2)).toISOString().split('T')[0],
      purposeId: "",
      modeId: "",
      classId: "",
      contactNo: "",
      parentAndGurdianName: "",
      reference: "",
      emailId: "",
      remark: "",
      createdBy: 0,
      teacherId: "",
      studentName: "",
      motherName: "",
      amount: 0,
      alternateMobile: ""
    });
    setMandatoryFieldsError(false);
  };

  const handlePurposeChange = (event) => {
    setEnquiryData({ ...enquiryData, purposeId: event.target.value });
  };

  const handleClassChange = (event) => {
    setEnquiryData({ ...enquiryData, classId: event.target.value });
  };

  const handleSubChange = (event) => {
    setEnquiryData({ ...enquiryData, teacherId: event.target.value });
  };

  const handleModeChange = (event) => {
    setEnquiryData({ ...enquiryData, modeId: event.target.value });
  };

  // Info sections data
  const infoSections = [
    {
      title: "📋 Page Overview",
      content:
        "The Add Enquiry page allows staff to record a new student admission enquiry. Fill in all required fields (marked with *) and click SAVE to submit. A notification is automatically sent upon successful submission.",
    },
    {
      title: "📝 Form Fields",
      items: [
        "Enquiry No. * – Auto-generated code for the new enquiry. This field is read-only.",
        "Enquiry Date * – Date of the enquiry. Defaults to today's date.",
        "Next Follow Up Date * – Scheduled date for the next follow-up. Defaults to today + 2 days. Past dates cannot be selected.",
        "Purpose * – Reason for the enquiry (e.g., new admission, transfer, information).",
        "Mode * – How the enquiry was received (e.g., walk-in, phone call, online).",
        "For Class * – The class/grade the student is enquiring about.",
        "Contact No. * – Primary 10-digit phone number. Automatically checks for existing enquiries when 10 digits are entered.",
        "Father Name * – Name of the father or primary guardian.",
        "Student Name * – Full name of the prospective student.",
        "Mother Name – Name of the mother (optional).",
        "Alternate Number – A secondary contact number (optional, max 10 digits).",
        "Email-Id – Email address for correspondence (optional).",
        "Assigned To * – Staff member responsible for following up on this enquiry.",
        "Reference – How the family heard about the school (optional).",
        "Remark – Additional notes or observations (optional).",
      ],
    },
    {
      title: "📞 Duplicate Contact Check",
      content:
        "When a 10-digit contact number is entered, the system automatically checks for existing enquiries linked to that number. If found, a 'View Details' button appears to review the previous enquiry before proceeding.",
    },
    {
      title: "⚙️ Actions",
      items: [
        "SAVE – Validates all required fields and submits the enquiry. Shows a missing fields popup if any required field is empty.",
        "RESET – Clears all form fields and resets to default values.",
      ],
    },
    {
      title: "✅ After Saving",
      content:
        "On successful submission, a confirmation dialog appears and an automatic notification is sent. Click OK to close and return to the previous page.",
    },
  ];

  return (
    <div>
      <Container sx={{ marginTop: 0 }}>
        <Box
          sx={{
            backgroundColor: '#0B1F40',
            padding: '12px 24px',
            boxShadow: 3,
            borderRadius: '4px 4px 0 0',
            marginBottom: '10px',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
            Add Enquiry
          </Typography>

          {/* Info Icon Button */}
          <Tooltip title="View page information & guide" arrow>
            <IconButton
              onClick={() => setShowInfoModal(true)}
              size="small"
              sx={{
                color: "rgba(255,255,255,0.75)",
                backgroundColor: "rgba(255,255,255,0.1)",
                border: "1.5px solid rgba(255,255,255,0.25)",
                borderRadius: "50%",
                width: 30,
                height: 30,
                ml: 0.5,
                transition: "all 0.2s ease",
                "&:hover": {
                  backgroundColor: "rgba(100,181,246,0.25)",
                  borderColor: "#64B5F6",
                  color: "#64B5F6",
                  transform: "scale(1.1)",
                },
              }}
            >
              <InfoIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </Tooltip>
        </Box>

        <Paper elevation={3} style={{ padding: '20px', marginTop: 6, }}>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2} mt={2}>
              <Grid item md={6}>
                <label htmlFor="enquiryCode"><strong>Enquiry No.</strong><span style={{ color: 'red' }}>*</span></label>
                <TextField
                  id="enquiryCode"
                  type="text"
                  fullWidth
                  placeholder="New"
                  value={enquiryData.enquiryCode}
                />
              </Grid>
              <Grid item md={6}>
                <label htmlFor="enquiryDate"><strong>Enquiry Date</strong><span style={{ color: 'red' }}>*</span></label>
                <TextField
                  id="enquiryDate"
                  type="date"
                  fullWidth
                  value={enquiryData.enquiryDate}
                  onChange={(e) => setEnquiryData({ ...enquiryData, enquiryDate: e.target.value })}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                {mandatoryFieldsError && !enquiryData.enquiryDate && <FormHelperText error>Please select enquiry date</FormHelperText>}
              </Grid>
            </Grid>
            <Grid container spacing={2} mt={2}>
              <Grid item md={6}>
                <label htmlFor="followupDate"><strong>Next Follow Up Date</strong><span style={{ color: 'red' }}>*</span></label>
                <TextField
                  id="followupDate"
                  type="date"
                  fullWidth
                  value={enquiryData.followupDate}
                  onChange={(e) => setEnquiryData({ ...enquiryData, followupDate: e.target.value })}
                  InputProps={{
                    inputProps: {
                      min: new Date().toISOString().split('T')[0] // Prevent selecting past dates
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                {mandatoryFieldsError && !enquiryData.followupDate && <FormHelperText error>Please select next followup date</FormHelperText>}
              </Grid>
              <Grid item xs={6} marginTop={-1}>
                <label htmlFor="purpose" className="form-label">
                  <strong>Purpose</strong><span style={{ color: 'red' }}>*</span>
                </label>
                <Select
                  id="purpose"
                  value={enquiryData.purposeId}
                  onChange={handlePurposeChange}
                  fullWidth
                >
                  <MenuItem value="">--Select--</MenuItem>
                  {purposes.map((purpose) => (
                    <MenuItem key={purpose.purposeId} value={purpose.purposeId}>
                      {purpose.purpose}
                    </MenuItem>
                  ))}
                </Select>
                {mandatoryFieldsError && !enquiryData.purposeId && <FormHelperText error>Please select purpose</FormHelperText>}
              </Grid>
            </Grid>
            <Grid container spacing={2} mt={2}>
              <Grid item xs={6}>
                <label htmlFor="mode" className="form-label">
                  <strong>Mode</strong><span style={{ color: 'red' }}>*</span>
                </label>
                <Select
                  id="mode"
                  value={enquiryData.modeId}
                  onChange={handleModeChange}
                  fullWidth
                >
                  <MenuItem value="">--Select--</MenuItem>
                  {modes.map((mode) => (
                    <MenuItem key={mode.modeId} value={mode.modeId}>
                      {mode.modeName}
                    </MenuItem>
                  ))}
                </Select>
                {mandatoryFieldsError && !enquiryData.modeId && <FormHelperText error>Please select mode</FormHelperText>}
              </Grid>
              <Grid item xs={6}>
                <label htmlFor="class" className="form-label">
                  <strong>For Class</strong><span style={{ color: 'red' }}>*</span>
                </label>
                <Select
                  id="class"
                  value={enquiryData.classId}
                  onChange={handleClassChange}
                  fullWidth
                >
                  <MenuItem value="">--Select--</MenuItem>
                  {classes.map((classItem) => (
                    <MenuItem key={classItem.classId} value={classItem.classId}>
                      {classItem.className}
                    </MenuItem>
                  ))}
                </Select>
                {mandatoryFieldsError && !enquiryData.classId && <FormHelperText error>Please select class</FormHelperText>}
              </Grid>
            </Grid>
            <Grid container spacing={2} mt={2}>
              <Grid item md={6}>
                <label htmlFor="contactNo"><strong>Contact No.</strong><span style={{ color: 'red' }}>*</span></label>
                <TextField
                  id="contactNo"
                  type="text"
                  fullWidth
                  value={enquiryData.contactNo}
                  onChange={handleContactChange}
                  inputProps={{ maxLength: 10 }}
                />
                {enquiryMessage && (
                  <FormHelperText
                    style={{
                      color: enquiryExists ? "red" : "green",
                    }}
                  >
                    {enquiryMessage}{" "}
                    {enquiryExists && (
                      <Button color="secondary" onClick={() => fetchEnquiryDetails(enquiryData.contactNo)}>
                        View Details
                      </Button>
                    )}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item md={6}>
                <label htmlFor="parentAndGurdianName"><strong>Father Name</strong><span style={{ color: 'red' }}>*</span></label>
                <TextField
                  id="parentAndGurdianName"
                  type="text"
                  fullWidth
                  value={enquiryData.parentAndGurdianName}
                  onChange={(e) => setEnquiryData({ ...enquiryData, parentAndGurdianName: e.target.value })}
                />
                {mandatoryFieldsError && !enquiryData.parentAndGurdianName && <FormHelperText error>Please enter father name</FormHelperText>}
              </Grid>
            </Grid>
            <Grid container spacing={2} mt={2}>
              <Grid item md={6}>
                <label htmlFor="studentName"><strong>Student Name</strong><span style={{ color: 'red' }}>*</span></label>
                <TextField
                  id="studentName"
                  type="text"
                  fullWidth
                  value={enquiryData.studentName}
                  onChange={(e) => setEnquiryData({ ...enquiryData, studentName: e.target.value })}
                />
                {mandatoryFieldsError && !enquiryData.studentName && <FormHelperText error>Please enter student name</FormHelperText>}
              </Grid>
              <Grid item md={6}>
                <label htmlFor="motherName"><strong>Mother Name</strong></label>
                <TextField
                  id="motherName"
                  type="text"
                  fullWidth
                  value={enquiryData.motherName}
                  onChange={(e) => setEnquiryData({ ...enquiryData, motherName: e.target.value })}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} mt={2}>
              <Grid item md={6}>
                <label htmlFor="alternateMobile"><strong>Alternate number</strong></label>
                <TextField
                  id="alternateMobile"
                  type="text"
                  fullWidth
                  value={enquiryData.alternateMobile}
                  inputProps={{ maxLength: 10 }}
                  onChange={(e) => setEnquiryData({ ...enquiryData, alternateMobile: e.target.value })}
                />
              </Grid>
              <Grid item md={6}>
                <label htmlFor="emailId"><strong>Email-Id</strong></label>
                <TextField
                  id="emailId"
                  type="text"
                  fullWidth
                  value={enquiryData.emailId}
                  onChange={(e) => setEnquiryData({ ...enquiryData, emailId: e.target.value })}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} mt={2}>
              <Grid item xs={6} marginTop={-1}>
                <label htmlFor="teacherId" className="form-label">
                  <strong>Assigned To</strong><span style={{ color: 'red' }}>*</span>
                </label>
                <Select
                  id="teacherId"
                  value={enquiryData.teacherId}
                  onChange={handleSubChange}
                  fullWidth
                >
                  <MenuItem value="">--Select--</MenuItem>
                  {subjects.map((subject) => (
                    <MenuItem key={subject.userId} value={subject.userId}>
                      {subject.employeeName}
                    </MenuItem>
                  ))}
                </Select>
                {mandatoryFieldsError && !enquiryData.teacherId && <FormHelperText error>Please select teacher</FormHelperText>}
              </Grid>
              <Grid item md={6}>
                <label htmlFor="reference"><strong>Reference</strong></label>
                <TextField
                  id="reference"
                  type="text"
                  fullWidth
                  value={enquiryData.reference}
                  onChange={(e) => setEnquiryData({ ...enquiryData, reference: e.target.value })}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} mt={2}>
              <Grid item xs={6}>
                <label htmlFor="remark"><strong>Remark</strong></label>
                <TextField
                  id="remark"
                  type="text"
                  fullWidth
                  value={enquiryData.remark}
                  onChange={(e) => setEnquiryData({ ...enquiryData, remark: e.target.value })}
                />
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <Button type="submit" variant="contained" color="primary" sx={{
                marginTop: 2, width: "100px",
                height: "50px",
                padding: "10px 0",
                fontWeight: 'bold'
              }}>
                SAVE
              </Button>
              <Button type="button" variant="contained" color="error" sx={{
                width: "100px",
                height: "50px",
                padding: "10px 0",
                fontWeight: 'bold'
                , marginTop: 2, marginLeft: 2
              }} onClick={handleReset}>
                RESET            </Button>
            </Grid>
          </form>
        </Paper>
      </Container>

      <Dialog open={modalOpen} onClose={handleModalClose} maxWidth="md" fullWidth>
        <DialogTitle>Enquiry Details</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} mt={2}>
            <Grid item md={6}>
              <label htmlFor="enquiryCode">Enquiry No.</label>
              <TextField
                id="enquiryCode"
                type="text"
                fullWidth
              />
            </Grid>
            <Grid item md={6}>
              <label htmlFor="enquiryDate">Enquiry Date</label>
              <TextField
                id="enquiryDate"
                type="text"
                fullWidth
                value={enquiryData.enquiryDate}
              />
            </Grid>
            <Grid item md={6}>
              <label htmlFor="followupDate">Next Followup Date</label>
              <TextField
                id="followupDate"
                type="text"
                fullWidth
                value={enquiryData.followupDate}
              />
            </Grid>
            <Grid item md={6}>
              <label htmlFor="parentAndGurdianName">Father Name</label>
              <TextField
                id="parentAndGurdianName"
                type="text"
                fullWidth
                value={enquiryData.parentAndGurdianName}
              />
            </Grid>
            <Grid item md={6}>
              <label htmlFor="studentName">Student Name</label>
              <TextField
                id="studentName"
                type="text"
                fullWidth
                value={enquiryData.studentName}
              />
            </Grid>
            <Grid item md={6}>
              <label htmlFor="motherName">Mother Name</label>
              <TextField
                id="motherName"
                type="text"
                fullWidth
                value={enquiryData.motherName}
              />
            </Grid>
            <Grid item md={6}>
              <label htmlFor="emailId">Email ID</label>
              <TextField
                id="emailId"
                type="email"
                fullWidth
                value={enquiryData.emailId}
              />
            </Grid>
            <Grid item md={6}>
              <label htmlFor="alternateMobile">Alternate Mobile</label>
              <TextField
                id="alternateMobile"
                type="text"
                fullWidth
                value={enquiryData.alternateMobile}
              />
            </Grid>
            <Grid item md={6}>
              <label htmlFor="refrence">Reference</label>
              <TextField
                id="refrence"
                type="text"
                fullWidth
                value={enquiryData.refrence}
              />
            </Grid>
            <Grid item md={6}>
              <label htmlFor="remark">Remark</label>
              <TextField
                id="remark"
                type="text"
                fullWidth
                value={enquiryData.remark}
              />
            </Grid>
            <Grid item md={6}>
              <label htmlFor="amount">Amount</label>
              <TextField
                id="amount"
                type="number"
                fullWidth
                value={enquiryData.amount}
              />
            </Grid>
            <Grid item md={6}>
              <label htmlFor="classId">Class</label>
              <TextField
                id="classId"
                type="text"
                fullWidth
                value={enquiryData.classId}
              />
            </Grid>
            <Grid item md={6}>
              <label htmlFor="modeId">Mode</label>
              <TextField
                id="modeId"
                type="text"
                fullWidth
                value={enquiryData.modeId}
              />
            </Grid>
            <Grid item md={6}>
              <label htmlFor="purposeId">Purpose</label>
              <TextField
                id="purposeId"
                type="text"
                fullWidth
                value={enquiryData.purposeId}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => navigate(`/editenquiry/${enquiryData.enquiryId}`)} color="primary" variant="contained">
            Update
          </Button>
          <Button onClick={handleModalClose} color="secondary" variant="outlined">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* ===== Info Modal ===== */}
      <Modal
        open={showInfoModal}
        onClose={() => setShowInfoModal(false)}
        aria-labelledby="info-modal-title"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '95%', sm: 620 },
            maxHeight: '85vh',
            bgcolor: 'background.paper',
            borderRadius: 3,
            boxShadow: '0 8px 40px rgba(11,31,61,0.22)',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {/* Modal Header */}
          <Box
            sx={{
              backgroundColor: '#0B1F3D',
              padding: '14px 20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <InfoIcon sx={{ color: '#64B5F6', fontSize: 22 }} />
              <Typography id="info-modal-title" variant="h6" sx={{ color: '#fff', fontWeight: 700 }}>
                Add Enquiry — Page Guide
              </Typography>
            </Box>
           
          </Box>

          {/* Modal Body — scrollable */}
          <Box sx={{ overflowY: 'auto', padding: '20px 24px', flex: 1 }}>
            {infoSections.map((section, idx) => (
              <Box key={idx} sx={{ mb: 2.5 }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 700,
                    color: '#0B1F3D',
                    mb: 0.8,
                    fontSize: '0.97rem',
                  }}
                >
                  {section.title}
                </Typography>

                {section.content && (
                  <Typography
                    variant="body2"
                    sx={{ color: '#444', lineHeight: 1.7, fontSize: '0.875rem' }}
                  >
                    {section.content}
                  </Typography>
                )}

                {section.items && (
                  <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
                    {section.items.map((item, i) => (
                      <Box
                        component="li"
                        key={i}
                        sx={{
                          fontSize: '0.875rem',
                          color: '#444',
                          lineHeight: 1.75,
                          mb: 0.3,
                        }}
                      >
                        {item}
                      </Box>
                    ))}
                  </Box>
                )}

                {idx < infoSections.length - 1 && (
                  <Divider sx={{ mt: 2, borderColor: 'rgba(11,31,61,0.08)' }} />
                )}
              </Box>
            ))}
          </Box>

          {/* Modal Footer */}
          <Box
            sx={{
              padding: '12px 24px',
              borderTop: '1px solid rgba(11,31,61,0.1)',
              display: 'flex',
              justifyContent: 'flex-end',
              backgroundColor: '#f9fafb',
            }}
          >
            <Button
              variant="contained"
              onClick={() => setShowInfoModal(false)}
              sx={{
                backgroundColor: '#0B1F3D',
                textTransform: 'none',
                fontWeight: 600,
                '&:hover': { backgroundColor: '#1a3560' },
              }}
            >
              Got it
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Submitted ✅
            </Typography>
          </Box>

          {/* Content */}
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Enquiry submitted successfully!
            </Typography>

            {/* Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1); // go back after closing modal
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={mandatoryFieldsError}
        onClose={() => setMandatoryFieldsError(false)}
        aria-labelledby="missing-fields-modal-title"
        aria-describedby="missing-fields-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="missing-fields-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Missing Fields
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="missing-fields-modal-description" sx={{ mb: 2 }}>
              The following fields are required:
            </Typography>
            <ul>
              {missingFields.map((field, index) => (
                <li key={index}>- {field}</li>
              ))}
            </ul>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => setMandatoryFieldsError(false)}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

<Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>

    </div>
  );
}

export default Enquiry;